import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Paper,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  TableContainer,
  Table,
  MenuItem as MuiMenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";

function ViewDataGridPdf({ columns, rows, tabletitle, gridid }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  if (!columns || !rows || !Array.isArray(columns) || !Array.isArray(rows)) {
    console.error("Invalid columns or rows");
    return null;
  }

  return (
    <Paper sx={styles.VDG_paper}>
      <TableContainer
        component={Paper}
        sx={{
          border: "1px solid black",
          bgcolor: "white",

          color: "black",
        }}
      >
        <Table
          size="small"
          aria-label={`${tabletitle} table`}
          sx={{ borderCollapse: "collapse" }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: "transparent" }}>
              {columns.map((col) => (
                <TableCell
                  key={col.field}
                  sx={{
                    border: "1px solid black",
                    color: "black",
                    fontWeight: "bold",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {col.headerName || col.field}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{ textAlign: "center", py: 2 }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
            {rows.map((row, idx) => (
              <TableRow key={row[gridid] || idx} sx={{ textAlign: "center" }}>
                {columns.map((col) => (
                  <TableCell
                    key={col.field}
                    sx={{
                      border: "1px solid black",
                      fontSize: 10,
                      px: 1,
                      py: 0.5,
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    {/* {row[col.field] ?? ""} */}

                    {col.format
                      ? col.format(row[col.field])
                      : row[col.field] ?? ""}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* If you have menuItems and anchorEl logic, you can keep your Menu here */}
    </Paper>
  );
}

ViewDataGridPdf.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node,
    })
  ).isRequired,
  tabletitle: PropTypes.string.isRequired,
  gridid: PropTypes.string.isRequired,
};

ViewDataGridPdf.defaultProps = {
  columns: [],
  rows: [],
  menuItems: [],
  tabletitle: "",
  gridid: "",
};

export default ViewDataGridPdf;
